export const BEIGE_BACKGROUND_CLASSES = {
  'sonder-formlib-light-background': false,
  'sonder-formlib-beige-background': true
};

export const WHITE_BACKGROUND_CLASSES = {
  'sonder-formlib-light-background': true,
  'sonder-formlib-beige-background': false
};
